/* RESPONSIBLE TEAM: team-workflows */
/* eslint-disable no-restricted-imports */
import {
  AT_CONVERSATION_START,
  NEW_FIN_AGENT_API_CONVERSATION_TARGET,
  NEW_FIN_AGENT_API_CONVERSATION_TRIGGER,
  TRIGGERABLE_BOT_TYPE,
  NON_USER_ROLE_PREDICATE,
  WORKFLOWS_SETUP_TRIGGER_START_CONVERSATION,
  WORKFLOWS_SETUP_TRIGGER_CUSTOMER_FACING,
} from 'embercom/lib/operator/custom-bots/constants';
import {
  matchBehaviors,
  objectTypes,
} from 'embercom/models/data/matching-system/matching-constants';

import CustomBotConfig, { type ColumnConfigs } from '../custom-bot';
import NewFinAgentApiConversationTargetEditorConfig from 'embercom/objects/visual-builder/configuration/editor/new-fin-agent-api-conversation-target';
import type { BotConfigTarget } from '../configuration';
import { type InterfaceIconName } from '@intercom/pulse/lib/interface-icons';
import { getApp } from 'embercom/lib/container-lookup';

export default class NewFinAgentApiConversationBotConfig extends CustomBotConfig {
  get rolePredicateGroup() {
    return { predicates: [NON_USER_ROLE_PREDICATE] };
  }

  get target(): BotConfigTarget {
    return NEW_FIN_AGENT_API_CONVERSATION_TARGET;
  }

  get botType() {
    return TRIGGERABLE_BOT_TYPE;
  }

  get objectType() {
    return objectTypes.triggerableCustomBot;
  }

  get trigger() {
    return NEW_FIN_AGENT_API_CONVERSATION_TRIGGER;
  }

  get matchBehavior() {
    return matchBehaviors.transient;
  }

  get titleTranslationKey() {
    return 'operator.custom-bot.trigger.new-fin-agent-api-conversation.title';
  }

  get isBeta() {
    return false;
  }

  get isNew() {
    return true;
  }

  get descriptionTranslationKey() {
    return 'operator.custom-bot.trigger.new-fin-agent-api-conversation.description';
  }

  get icon(): InterfaceIconName {
    return 'code';
  }

  get editorConfig() {
    return new this.EditorConfigClass({
      targetChannels: this.customBot?.targetChannels,
      areStepPaywallsActive: this.areStepPaywallsActive,
      workflow: this.workflow,
    });
  }

  get EditorConfigClass() {
    return NewFinAgentApiConversationTargetEditorConfig;
  }

  get columnKeys(): (keyof ColumnConfigs)[] {
    let baseColumns: (keyof ColumnConfigs)[] = super.columnKeys;
    let idx = 2;

    if (getApp().canUseFeature('team-workflows-workflow-type-column')) {
      idx++;
    }

    return [...baseColumns.slice(0, idx), 'channels', ...baseColumns.slice(idx)];
  }

  visibleToApp(_app: any) {
    return true;
  }

  get requiredBillingFeature() {
    return 'workflows_core_billing_feature';
  }

  get triggerContextType() {
    return AT_CONVERSATION_START;
  }

  get workflowsSetupTriggerType(): string[] {
    return [WORKFLOWS_SETUP_TRIGGER_START_CONVERSATION, WORKFLOWS_SETUP_TRIGGER_CUSTOMER_FACING];
  }
}
